import React, { useMemo } from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@this/shared/ui/data_displays/table';

const SameDayCancelRuleTable: React.FC = () => {
  const styles = useMemo(() => getStyles(), []);
  return (
    <>
      <Table style={styles.table}>
        <TableHead>
          <TableRow>
            <TableCell th style={styles.headerCell}>
              出発時刻
            </TableCell>
            <TableCell th style={styles.headerCell}>
              キャンセル依頼期限
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell style={styles.cell}>～10:59</TableCell>
            <TableCell style={styles.cell}>前営業日※ 18:00まで</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={styles.cell}>11:00～20:00</TableCell>
            <TableCell style={styles.cell}>出発時刻の2時間前まで</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={styles.cell}>20:01～</TableCell>
            <TableCell style={styles.cell}>当日 18:00まで</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <p style={styles.noteHeading}>※「前営業日」はプレミアムオプションの有無によって異なります</p>
      <p style={styles.noteLine}>あり：土日祝を含む前日 ／ なし：直前の平日（土日祝除く）</p>
      <p style={styles.noteExample}>例）月曜日出発の場合 → あり：日曜日 18:00／なし：金曜日 18:00</p>
    </>
  );
};

const getStyles = () => {
  const cell: React.CSSProperties = {
    border: '1px solid #d3d7db',
    padding: '8px 12px',
    verticalAlign: 'top',
    fontSize: 13,
    fontFamily: 'inherit',
    lineHeight: 'inherit',
    letterSpacing: 'inherit',
    backgroundColor: 'transparent'
  };
  return {
    table: {
      borderCollapse: 'collapse' as const,
      marginBottom: 12,
      width: '100%',
      fontSize: 13
    },
    headerCell: {
      ...cell,
      backgroundColor: '#f4f5f6',
      fontWeight: 'bold' as const
    },
    cell,
    noteHeading: {
      fontSize: 13,
      marginBottom: 6
    },
    noteLine: {
      fontSize: 13,
      marginBottom: 4,
      paddingLeft: 16
    },
    noteExample: {
      fontSize: 13,
      marginBottom: 0,
      paddingLeft: 16
    }
  };
};

export default SameDayCancelRuleTable;
